<template>
    <div>
        <v-tabs grow color="secondary" dark icons-and-text>
            <v-tabs-slider color="accent"></v-tabs-slider>
<!--            <v-tab href="#refund">-->
<!--                Refund-->
<!--                <v-icon color="white">money</v-icon>-->
<!--            </v-tab>-->
            <v-tab href="#pending">
                Pending
                <v-icon color="white">fa fa-clock-o</v-icon>
            </v-tab>
            <v-tab href="#done">
                Done
                <v-icon color="white">fa fa-check</v-icon>
            </v-tab>
<!--            <v-tab-item value="refund">-->
<!--                <refund/>-->
<!--            </v-tab-item>-->
            <v-tab-item value="pending">
                <NewAccounting/>
            </v-tab-item>
            <v-tab-item value="done">
                <DoneAccounting/>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import NewAccounting from "@/views/accounting/NewAccounting";
    import DoneAccounting from "@/views/accounting/DoneAccounting";
   
    export default {
        name: "AccountingTabs",
        title: 'Accounting Tabs',
        components: {NewAccounting,DoneAccounting,LoadingComponent},
        data() {
            return {
                loading: false,
            }
        }
    }
</script>

<style scoped>

</style>